export class RuleActionData {
  type?: string;
  fieldName: string;
  mandatory?: boolean;
  entity?: string;
  value?: any;
  values?: any[];
  options?: string[];
  supportMultiValues?: boolean;
  entityTypeValue?: string;
  dataList?: RuleActionData[];

  constructor(ruleActionData: RuleActionData) {
    this.type = ruleActionData.type;
    this.fieldName = ruleActionData.fieldName;
    this.mandatory = ruleActionData.mandatory;
    this.entity = ruleActionData.entity;
    this.value = ruleActionData.value;
    this.values = ruleActionData.values;
    this.options = ruleActionData.options;
    this.entityTypeValue = ruleActionData.entityTypeValue;
    this.dataList = ruleActionData.dataList;
    this.supportMultiValues = ruleActionData.supportMultiValues;
  }

  get id(): string {
    if (this.entity) {
      return this.entity + this.fieldName;
    } else {
      return this.fieldName;
    }
  }
}
